module.exports = {"id":"198386","name":"Sebastián Dubarbier","rating":"73","photo":"./data/images/photos/1/198386.png","club":{"name":"Estudiantes","logo":"./data/images/clubs/Estudiantes.png"},"positions":["DG","DLG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastianDubarbier0.json
// module id = 3858
// module chunks = 0